import React, { Component } from 'react';
import Form from './Form';
import Button from '../Field_Components/Button/Button';
import {
    Page
    , Content
    , Nav
    , Loading
    , Footer
    , SafeAreaWrap
} from '@beisen/chaos-ui';
import * as fieldLinkageUtils from '../util/fieldLinkageUtils';
import { getExtensionCmp } from '../util/extension';
import SubLoading from './SubLoading/loading';
import {
    ifHidePopupNav,
    generateHeaderConfig,
    clearHeaderConfig,
    deepClone
} from '../util/helper';
import transLoader from '@beisen/i18n-translation-loader';
import classNames from 'classNames';
import { addEnNavClassName } from '../util/ui';
require('./EditForm.scss');

const defaultTranslation = {
    confirm: '确定',
    cancel: '取消'
};

function noop() { }

/**
  * 获取表单加载后需要加载的数据源
  * 数据源应该是树形字段依赖关系的根节点，寻找根节点
  * @param {*} fieldDependenceRaw
  */
 function getFirstLoadDataSource(fieldDependenceRaw = []) {
    // 构造引用计数，(作为控制字段出现一次)且(没有作为依赖字段出现)的字段就是根节点
    let refCounter = {};

    // 增加引用计数
    const add = (fieldName, isControlField, counter) => {
        if (counter[fieldName] === undefined) {
            counter[fieldName] = isControlField ? { control: 1, dependence: 0 } : { control: 0, dependence: 1 };
        } else {
            if (isControlField) {
                counter[fieldName].control++;
            } else {
                counter[fieldName].dependence++;
            }
        }
    };

    const getRootNodes = counter => {
        let nodes = [];
        const isRootNode = node => node.control > 0 && node.dependence === 0;
        for (let fieldName in counter) {
            isRootNode(counter[fieldName]) && nodes.push(fieldName);
        }
        return nodes;
    };

    const getOtherNodes = (counter, rootNodes) => {
        let nodes = [];
        for (let fieldName in counter) {
            if (rootNodes.indexOf(fieldName) < 0) {
                nodes.push(fieldName);
            }
        }
        return nodes;
    };

    fieldDependenceRaw && Array.isArray(fieldDependenceRaw) && fieldDependenceRaw.forEach(dependence => {       //dependence:{control:'dependence'}
        let controlField = dependence.aclFieldName;
        let dependenceField = dependence.dependenceFieldName;
        add(controlField, true, refCounter);
        add(dependenceField, false, refCounter);
    });

    let firstLoad = getRootNodes(refCounter);
    let notLoad = getOtherNodes(refCounter, firstLoad);

    return {
        firstLoad,
        notLoad
    };
}

class EditForm extends Component {
    constructor(props) {
        super(props);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.saveFormData = this.saveFormData.bind(this);
        this.toggleDisableButton = this.toggleDisableButton.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.getRefreshParams = this.getRefreshParams.bind(this);

        this.state = {
            disabled: false,
            isShowLoading: false
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            confirm: 'common.confirm',
            cancel: 'common.cancel'
        }), props.translation);
    }


    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        const title = this.props.popOptions.params.title;
        generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'editFormCancel',
                    control: true,
                    text: '',
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);
            if (title) {
                config.titleItem = {
                    text: title,
                    control: false
                };
            }
            return config;
        });
    }

    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        clearHeaderConfig();
    }

    //注册壳子回调函数
    registCallback() {
        window.globalEventManager['editFormCancel'] = this.cancelEdit.bind(this);
    }

    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['editFormCancel'];
    }

    componentDidMount() {
        this.firstLoad = true;
        const { cmp_id, popOptions } = this.props;
        this.props.actions.fetchFormData(cmp_id, popOptions, this.getQueryParam());

        if (ifHidePopupNav() && !this.props.hideHeader) {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillUnmount() {
        if (ifHidePopupNav() && !this.props.hideHeader) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.form_errors || nextProps.error) || (!nextProps.confirmData && this.props.confirmData && typeof nextProps.confirmData === 'undefined')) {
            this.state.disabled ? this.setState({ disabled: false, isShowLoading: false }) : null;
        }
        if (nextProps.cmp_data || !nextProps.isFetching) {
            document.getElementsByClassName('jumpLoad') && document.getElementsByClassName('jumpLoad')[0] && (document.getElementsByClassName('jumpLoad')[0].style.display = 'none');
        }

        // 这段代码永远不会走进来，因为isFetchingDataSource外面没有传进来，但是没有引起什么bug，加了之后
        // 反而会引起联动bug，formInitialized方法和_editFormInitialDataSource方法代码是一样的
        // 不知道历史问题是啥，这里先别动了
        if ((this.props.cmp_data && this.props.cmp_data.cmp_state == 'edit') && (this.props.isFetchingDataSource !== nextProps.isFetchingDataSource)) {
            this._editFormInitialDataSource();
        }
    }

    //处理联动规则数据
    formInitialized(props) {
        if (!props.cmp_data.rules) return false;
        const storeRootNodeContainForm = props.storeRootName || 'buttonData';
        const formattedRules = fieldLinkageUtils.assembleExpressions(props.cmp_data.rules || [], false);
        const expression = {
            sources: formattedRules[0],
            watchFields: formattedRules[1]
        };
        const context = {};
        const sourceParams = this.refs.editForm.getDataSourceNames();
        this.props.actions.watchFormFields(expression, props.cmp_id, storeRootNodeContainForm, context, sourceParams, false);
    }

    componentDidUpdate() {
        if (this.props.fetchSuccess && this.firstLoad) {
            const { cmp_id } = this.props;
            if (this.refs.editForm) {
                this.formInitialized(this.props); //format联动规则
                let notLoad = getFirstLoadDataSource(this.props.cmp_data.fieldDependence).notLoad || [];
                // const notLoadShort = notLoad.map(fieldName => fieldName.indexOf(':') >= 0 ? fieldName.split(':')[1] : fieldName);
                let dataSourceNeedLoad = [],
                    dataSourceNotLoad = [],
                    allDataSources = this.refs.editForm.getDataSourceNames();
                    allDataSources.forEach(datasource => {
                        if(notLoad.indexOf(datasource.fieldName) < 0) {
                            dataSourceNeedLoad.push(datasource);
                        }else{
                            dataSourceNotLoad.push(datasource);
                        }
                    });
                // });

                this.props.actions.fetchDependenceFieldDataSource({
                    cmp_data: this.props.cmp_data,
                    biz_data: this.props.biz_data,
                    sub_cmps: this.props.sub_cmps,
                    cmp_id: this.props.cmp_id
                }, this.getMetaObjName());
                dataSourceNeedLoad.forEach(dataSource => dataSource.fieldName = dataSource.fieldName.indexOf(':') >= 0 ? dataSource.fieldName.split(':')[1] : dataSource.fieldName);
                this.props.actions.fetchDataSource(this.getMetaObjName(), dataSourceNeedLoad, cmp_id, dataSourceNotLoad, this.props.cmp_data.fieldDependence);
                this.firstLoad = false;
            }
        }
    }

    //编辑态表单初始化时默认走一次联动刷新数据源
    _editFormInitialDataSource() {
        if (!this.props.cmp_data.rules) return false;
        const storeRootNodeContainForm = this.props.storeRootName || 'buttonData';
        const formattedRules = fieldLinkageUtils.assembleExpressions(this.props.cmp_data.rules || [], true);
        const expression = {
            sources: formattedRules[0],
            watchFields: formattedRules[1]
        };
        const context = {};
        const sourceParams = this.refs.editForm.getDataSourceNames();
        this.props.actions.watchFormFields(expression, this.props.cmp_id, storeRootNodeContainForm, context, sourceParams, true);
    }

    cancelEdit(e) {
        e && e.preventDefault && e.preventDefault();
        e && e.persist && e.persist();
        if (this.props.onCancle) {
            this.props.onCancle();
        } else {
            this.props.clearTipHandler && this.props.clearTipHandler();
            this.props.actions.btnClearFn();
        }
    }

    saveFormData(e) {
        if (this.props.isFetching) return;
        this.startLoading();
        //点击保存时通知其他页面
        this.savePostMessage();
        if (!this.state.disabled) {
            this.toggleDisableButton(true);
            setTimeout(() => {
                this.refs.editForm.saveForm();
            }, 350);
        }
    }
    savePostMessage() {
        try {
            window.postMessage(JSON.stringify({
                actionType: 'form_hide_operation',
                message: 'formCancelOperation'
            }), '*');
        } catch (e) {
            // console.log("postMessage error")
        }

    }

    startLoading() {
        this.setState({ isShowLoading: true });
    }

    stopLoading() {
        this.setState({ isShowLoading: false, disabled: false });
    }

    toggleDisableButton(disable) {
        this.setState({ disabled: disable });
    }

    getMetaObjName() {
        return this.props.popOptions.params.metaObjName || this.props.popOptions.cmpContext.metaObjName;
    }

    getParentParams() {
        const { queryUrl = {},cmpContext = {} } = this.props.popOptions;
        const parentDataId = cmpContext.parentDataId || cmpContext.pObjectDataID;
        const parentMetaObjName = queryUrl.pageModule ? JSON.parse(decodeURIComponent(queryUrl.pageModule)).metaObjName : queryUrl.metaObjName;
        if(parentDataId && parentMetaObjName) {
            const parentParams = {
                parentDataId,
                parentMetaObjName,
                pObjectDataID: cmpContext.pObjectDataID
            };
            return parentParams;
        }
    }
    // button事件参数
    getButtonParams() {
         // 20181030依照PC端逻辑变更 业务有增加其他自定义参数的需求 这里改为反向逻辑 去掉不必要参数之后将其他参数都拼接上去
         let tempParams = deepClone(this.props.popOptions.params);

         // 所有无需增加到 formview 请求的属性
         const removeKeys = ['id', 'ids', '_id', 'dataRows', 'dataType', 'formSaveUrl', 'formState', 'metaObjName', 'ref', 'title', 'type', 'tempType', 'viewName', 'titleIcon', 'CurrentApprovalUserIDsText'];
         // 去掉所有 object 类型的属性，因为无法通过表单直接传递
         // 去掉 queryBody 和 _datas_ 开头的属性 因为这些属性是给 form 保存时使用的
         for(let key in tempParams) {
             if (typeof tempParams[key] == 'object' || key.indexOf('queryBody_') == 0 || key.indexOf('_datas_') == 0 || removeKeys.includes(key)) {
                 delete tempParams[key];
             }
         }
         return tempParams;
    }
    // 扩展弹出自定义表单 formview追加自定义参数
    getExtensionParams() {
        // urlParams 盛放的是需要追加到formView 接口地址的查询字传
        return this.props.buttonData && this.props.buttonData.urlParams;
    }

    // 组装formview接口url参数
    getQueryParam() {
        const { data = {},params: buttonParams = {},version } = this.props.popOptions;
        const id = data.id ? data.id.value || data.id : undefined;
        let params = {
            id,
            version,
            metaObjName: this.getMetaObjName(),
            viewName: buttonParams.viewName,
            formState: this.props.isBatch ? 'create' : buttonParams.formState
        };

        if (buttonParams.formState === 'create') {
            delete buttonParams.id;
        }
	    return Object.assign(params, this.getParentParams(),this.getExtensionParams(),this.getButtonParams());
    }

    onTouchMove() {
        document.activeElement && document.activeElement.blur();
    }

    getRefreshParams(template) {
        return fieldLinkageUtils.getRefreshParams(
            template,
            this.props,
            this._getQueryString(),
            this.props.biz_data
        );
    }

    // 为表单项增加额外的附加上下文，用于获取视图或者详情页的搜索条件、选中数据以及store上的任何数据
    genExtendFormContext() {
        let result = {};
        const { popOptions = {}, dataArr, tabelListPostParam, searchParam } = this.props;
        // 仅在按钮上配置了该参数，且类型是form时才传递
        if (popOptions.params && popOptions.params.extendFormContext) {
            const contextArr = popOptions.params.extendFormContext.split('|');
            contextArr.forEach(function(item) {
                if (item == 'selectedData') {
                    result[item] = Array.isArray(dataArr) ? dataArr : [];
                } else if (item == 'searchCondition') {
                    const searchParams = {
                        table_data: tabelListPostParam,
                        search_data: searchParam
                    };
                    result[item] = searchParams;
                } else if (item.indexOf('STORE/') == 0) {
                    let path = item.split('/');
                    path.shift(); // 去除前缀，因为store上没有这个值
                    if (path.length < 1) {
                        return;
                    } else {
                        const channel = window.store.getState()[path[0]];
                        result[item] = channel && channel.getIn(path.slice(1)).toJS();
                    }
                }
            });
        }
        return result;
    }

    _getQueryString() {
        let formUrlOption = this._getFormUrlOption();

        Object.assign(formUrlOption, { app: window.BSGlobal.application });
        if (formUrlOption.formState == 'create') {
            delete formUrlOption.id;
        }
        delete formUrlOption.shadow_context;
        let queryString = '';
        // for (let key in formUrlOption) {
        //     queryString += key + '=' + formUrlOption[key] + '&';
        // }
        // return queryString.substr(0, queryString.length - 1);
        return formUrlOption;
    }
    _getFormUrlOption() {
        const { popOptions } = this.props;
        const id = popOptions.id || popOptions.ids || '';
        const metaObjName = popOptions.formViewMetaObjName || popOptions.metaObjectName || popOptions.metaObjName;
        const formState = popOptions.params && popOptions.params.formState;
        const viewName = popOptions.params && popOptions.params.viewName;
        let getOptions = {};
        // 这里添加判断条件  针对新建表单  不需要添加id这个参数  又因为业务表单需要这个id  所以事件参数添加needsIds参数   即使是新建按钮也会传递id参数
        if (popOptions.formState == 'create' && !popOptions.needsIds) {
            getOptions = {
                metaObjName,
                formState
            };
        } else {
            getOptions = {
                metaObjName,
                formState,
                id
            };
        }
        if (viewName) {
            getOptions.viewName = viewName;
        }

        getOptions = this.addParentData(getOptions);
        return getOptions;
    }
    addParentData(obj) {
        // 201803变更 业务有增加其他自定义参数的需求 这里改为反向逻辑 去掉不必要参数之后将其他参数都拼接上去
        let popOptions = deepClone(this.props.popOptions);

        // 去掉所有 object 类型的属性，因为无法通过表单直接传递
        // 去掉 queryBody 和 _datas_ 开头的属性 因为这些属性是给 form 保存时使用的
        for (let key in popOptions) {
            if (typeof popOptions[key] == 'object' || key.indexOf('queryBody_') == 0 || key.indexOf('_datas_') == 0) {
                delete popOptions[key];
            }
        }

        // 所有无需增加到 formview 请求的属性
        let filter = ['id', 'ids', '_id', 'dataRows', 'dataType', 'formSaveUrl', 'formState', 'metaObjName', 'ref', 'title', 'type', 'tempType', 'viewName', 'titleIcon', 'jumpUrl', 'blank', 'CurrentApprovalUserIDsText'];
        filter.forEach(item => {
            delete popOptions[item];
        });

        Object.assign(obj, popOptions);
        return obj;
    }

    render() {
        const { translation } = this;
        const { popOptions, isFetching, cmp_data, biz_data } = this.props;
        const FormComponent = getExtensionCmp(this.props) || Form;
        const enNavButtonClass = addEnNavClassName();
        return (
            <Page cls="edit-form" onTouchTap={this.handleTouch}>
                {this.props.hideHeader || ifHidePopupNav() ? null :
                    <Nav cls="editform-navbar" title={popOptions.params.title}>
                        <a role="left" href='javascript:;'
                            className={classNames('editform-cancle-btn', enNavButtonClass)}
                            onTouchTap={this.cancelEdit}>
                            {popOptions.params.formCanelLabel || translation.cancel}
                        </a>
                    </Nav>}
                <Content ref="pageContent" onTouchTap={this.onTouchMove}>
                    {!cmp_data || isFetching ? <Loading /> :
                        <FormComponent
                            ref="editForm"
                            {...this.props}
                            containerContext={{ extendFormContext: this.genExtendFormContext() }}
                            onSaveDataSuccess={(this.props.params && this.props.params.success) || null}
                            saveFormData={this.props.saveFormData}
                            changeSuccess={this.props.changeSuccess}
                            toggleDisableButton={this.toggleDisableButton}
                            editReadOnly
                            confirmData={this.props.confirmData}
                            stopLoading={this.stopLoading}
                            startLoading={this.startLoading}
                            getRefreshParams={this.getRefreshParams}
                        />
                    }
                </Content>
                {this.state.isShowLoading ? <SubLoading /> : null}
                <Footer>
                    <SafeAreaWrap safeAreaStyle={{ background: '#f5f6f7' }}>
                        <Button type="primary" cmp_label={popOptions.params.formSaveLabel || translation.confirm} disabled={this.state.disabled} onTouchTap={this.saveFormData} />
                    </SafeAreaWrap>
                </Footer>
            </Page>
        );
    }
}

EditForm.defaultProps = {
    saveFormData: noop
};

export default EditForm;



// WEBPACK FOOTER //
// ./src/components/Form/EditForm.js